export const SET_FOUND_DOM = 'SET_FOUND_DOM'
export const SET_FOUND_AXIOS_SOURCE = 'SET_FOUND_AXIOS_SOURCE'
export const CLEAR_FOUND_AXIOS_SOURCE = 'CLEAR_FOUND_AXIOS_SOURCE'
